import { ref, reactive, watch, computed } from "vue";
import colorTool from "@/utils/color";
import i18n from "@/locales";
import http from "@/utils/request";
import tool from "@/utils/tool";

/*--------------------1.主题数据*/
//1.1 localstore的主题配置
const _key = "_APP_SETTING_";
const config = tool.data.get(_key) || {};
//1.2 默认主题配置
const defaultTheme = ref({
	isMobile: false, //移动端布局
	layout: "default", //布局
	menuIsCollapse: false, //菜单是否折叠 toggle
	layoutTags: true, //多标签栏
	theme: "", //主题
	dark: false, //黑夜模式
	lang: "zh-cn", //语言
	color: "#409EFF", //主图色
});
const setting = ref({
	isMobile: config.isMobile || defaultTheme.value.isMobile,
	layout: config.layout || defaultTheme.value.layout,
	menuIsCollapse: config.menuIsCollapse || defaultTheme.value.menuIsCollapse,
	layoutTags: config.layoutTags || defaultTheme.value.layoutTags,
	theme: config.theme || defaultTheme.value.theme,
	dark: config.dark || defaultTheme.value.dark,
	lang: config.lang || defaultTheme.value.lang,
	color: config.color || defaultTheme.value.color,
});
//1.3 数据库中的主题配置
const getDefaultTheme = () => {
	var xhr = new XMLHttpRequest();
	var domain = window.config.env.request.url.base;
	xhr.open("get", `${domain}/systemConfig/detail/theme`);
	xhr.onreadystatechange = () => {
		if (xhr.readyState == 4 && xhr.status == 200) {
			let r = JSON.parse(xhr.responseText);
			if (r.success && r.data && r.data.configInfo) {
				defaultTheme.value = JSON.parse(r.data.configInfo);
				setting.value = {
					isMobile: config.isMobile || defaultTheme.value.isMobile,
					layout: config.layout || defaultTheme.value.layout,
					menuIsCollapse:
						config.menuIsCollapse ||
						defaultTheme.value.menuIsCollapse,
					layoutTags:
						config.layoutTags || defaultTheme.value.layoutTags,
					theme: config.theme || defaultTheme.value.theme,
					dark: config.dark || defaultTheme.value.dark,
					lang: config.lang || defaultTheme.value.lang,
					color: config.color || defaultTheme.value.color,
				};
				tool.data.set(_key, JSON.stringify(setting.value));
			}
		}
	};
	xhr.send();
	// http.get(`/systemConfig/detail/theme`).then(r=>{
	// 	if(r.success&&r.data&&r.data.configInfo){
	// 		defaultTheme.value=JSON.parse(r.data.configInfo);
	// 		setting.value={
	// 			isMobile:config.isMobile||defaultTheme.value.isMobile,
	// 			layout:config.layout||defaultTheme.value.layout,
	// 			menuIsCollapse:config.menuIsCollapse||defaultTheme.value.menuIsCollapse,
	// 			layoutTags:config.layoutTags||defaultTheme.value.layoutTags,
	// 			theme:config.theme||defaultTheme.value.theme,
	// 			dark:config.dark||defaultTheme.value.dark,
	// 			lang:config.lang||defaultTheme.value.lang,
	// 			color:config.color||defaultTheme.value.color
	// 		};
	// 		tool.data.set(_key,JSON.stringify(setting.value));
	// 	}
	// })
};
getDefaultTheme();
//1.4合并本地缓存和数据库中配置，放到内存。并通过监听变化，实时保存
watch(
	() => setting.value,
	(val) => {
		tool.data.set(_key, JSON.stringify(setting.value));
	}
);

/*--------------------2.操作*/
//2.1黑夜模式切换
const handlerDarkChange = (val) => {
	if (val) {
		document.documentElement.classList.add("dark");
	} else {
		document.documentElement.classList.remove("dark");
	}
};
watch(() => setting.value.dark, handlerDarkChange, { immediate: true });
//2.2主题色切换
const handlerColorChange = (val) => {
	document.documentElement.style.setProperty("--el-color-primary", val);
	for (let i = 1; i <= 9; i++) {
		document.documentElement.style.setProperty(
			`--el-color-primary-light-${i}`,
			colorTool.lighten(val, i / 10)
		);
	}
	for (let i = 1; i <= 9; i++) {
		document.documentElement.style.setProperty(
			`--el-color-primary-dark-${i}`,
			colorTool.darken(val, i / 10)
		);
	}
};
watch(() => setting.value.color, handlerColorChange, { immediate: true });
//2.3语言切换
const handlerI18nChange = (val) => {
	i18n.global.locale = val;
};
watch(() => setting.value.lang, handlerI18nChange, { immediate: true });
//2.4手机模式自适应
setting.value.isMobile = document.body.clientWidth < 992;
window.addEventListener("resize", () => {
	setting.value.isMobile = document.body.clientWidth < 992;
});

export const toggleMenuCollapse = () => {
	setting.value.menuIsCollapse = !setting.value.menuIsCollapse;
};
export const useSetting = () => {
	return setting.value;
};
export const setSetting = ($obj) => {
	setting.value = $obj;
};
